module.exports = __webpack_public_path__ + "5c18a80179041c61444e2d4fac6c09f9.png";